export var credentials = {
    client_id: 1234,
    client_secret: 'secret',
    host: 'https://qa.unl.edu.ec/siaaf'
    // host: 'http://127.0.0.1:8000'
};

export var appService = {

    modulo_nombre: 'recaudacion',

    /*
     * URLS relacionadas al modulo SEGURIDAD
     * Usuario
     * Funcionalidad Group
     */
    ws_seguridad_loguin: credentials.host + "/api/v1/seguridad/token/",
    ws_seguridad_usuario_logueado: credentials.host + "/api/v1/seguridad/usuario-logueado",
    ws_seguridad_usuario_logueado_funcionalidades: credentials.host + "/api/v1/seguridad/usuario-logueado-funcionalidades/",
    ws_seguridad_usuario_lista: credentials.host + "/api/v1/seguridad/usuario/lista",
    ws_seguridad_usuario_tiene_permiso: credentials.host + "/api/v1/seguridad/usuario/tiene-permiso",

    /*
     * URLS relacionadas al modulo RECAUDACIÓN
     * CRUD de Establecimientos con sus Puntos de Emisión.
     * CRUD Productos
     * CRUD Ordenes de Pago
     * Generación y emisón de facturas y notas de credito
     */
    ws_recuadacion_empresa_detalle: credentials.host + "/api/v1/recaudacion/empresa/detalle/",
    ws_recuadacion_establecimiento_lista: credentials.host + "/api/v1/recaudacion/establecimiento/lista",
    ws_recuadacion_establecimiento_lista_usuario: credentials.host + "/api/v1/recaudacion/establecimiento/lista/usuario",
    ws_recaudacion_establecimiento_puntos_emision: credentials.host + "/api/v1/recaudacion/establecimiento/puntos-emision",
    ws_recaudacion_productos: credentials.host + "/api/v1/recaudacion/productos",
    ws_recaudacion_productos_paginacion: credentials.host + "/api/v1/recaudacion/productos/get_productos_por_paginacion",
    ws_recaudacion_puntos_emision: credentials.host + "/api/v1/recaudacion/puntos-emision",
    ws_recaudacion_ordenes_pago: credentials.host + "/api/v1/recaudacion/ordenes-pago",
    ws_recaudacion_ordenes_pago_paginacion: credentials.host + "/api/v1/recaudacion/orden-pago-paginacion",
    ws_recaudacion_ordenes_pago_pendientes_paginacion: credentials.host + "/api/v1/recaudacion/orden-pago-pendientes-paginacion",
    ws_recaudacion_ordenes_pago_pendientes_descripcion: credentials.host + "/api/v1/recaudacion/orden-pago-pendientes-descripcion",

    ws_recaudacion_ordenes_pago_importar_validar: credentials.host + "/api/v1/recaudacion/orden-pago-importar-pagos/validar",
    ws_recaudacion_ordenes_pago_importar_guardar: credentials.host + "/api/v1/recaudacion/orden-pago-importar-pagos/guardar",

    ws_recaudacion_comprobante: credentials.host + "/api/v1/recaudacion/comprobante",
    ws_recaudacion_comprobante_lista_emitidas: credentials.host + "/api/v1/recaudacion/comprobante-lista-emitidas",
    ws_recaudacion_comprobante_guardar_credito_base_factura: credentials.host + "/api/v1/recaudacion/comprobante-guardar-credito-base-factura",
    ws_recaudacion_comprobante_reporte_detalle: credentials.host + "/api/v1/recaudacion/comprobante-reporte-detalle",
    ws_recaudacion_comprobante_reporte_generadas: credentials.host + "/api/v1/recaudacion/comprobante-reporte-generadas",
    ws_recaudacion_comprobante_reporte_guardadas: credentials.host + "/api/v1/recaudacion/comprobante-reporte-guardadas",
    ws_recaudacion_orden_pago_reporte_detalle: credentials.host + "/api/v1/recaudacion/orden-pago-reporte-detalle",
    ws_recaudacion_orden_pago_reporte_consolidado: credentials.host + "/api/v1/recaudacion/orden-pago-reporte-consolidado",
    ws_recaudacion_orden_pago_reporte_productos: credentials.host + "/api/v1/recaudacion/orden-pago-reporte-productos",
    ws_recaudacion_orden_pago_reporte_banco_pichicha: credentials.host + "/api/v1/recaudacion/orden-pago-reporte-banco-pichicha",

    /**
     * URLS relacionadas al modulo CORE
     * Empresa
     * Catalogos Items
     * Personas
     * Direcciones
     */
    ws_core_catalogo_item_por_codigo: credentials.host + "/api/v1/core/catalogo-item-por-codigo",
    ws_core_catalogo_item_lista_por_catalogo: credentials.host + "/api/v1/core/catalogo-item-lista-por-catalogo",
    ws_core_empresa_lista: credentials.host + "/api/v1/core/empresa/lista",
    ws_core_persona_o_registrocivil: credentials.host + "/api/v1/core/persona-o-registrocivil",
    ws_core_persona_lista_paginacion: credentials.host + "/api/v1/core/persona-lista-paginacion",
    ws_core_persona_lista_direcciones: credentials.host + "/api/v1/core/persona-lista-direcciones",


    /**
     * URLS relacionadas al modulo ORGÁNICO
     * URLS relacionadas al modulo CONFIGURACIÓN
     *
     */
    ws_organico_uaa_lista_padres: credentials.host + '/api/v1/organico/uaa-lista-padres',
    ws_organico_uaa_lista_hijas: credentials.host + '/api/v1/organico/uaa-lista-hijas',
    ws_configuracion_detalle_parametrizacion_lista_por_padre: credentials.host + '/api/v1/configuracion/detalle-parametrizacion-lista-por-padre',
    ws_configuracion_detalle_parametrizacion_por_codigo: credentials.host + '/api/v1/configuracion/detalle-parametrizacion-por-codigo',

}
